import CreateNewInfoPersonInModifyInfoPersons from "../APL/CreateNewInfoPersonInModifyInfoPersons";
import { useEffect, useState } from "react";
import Select from "react-select";
import {
  Card,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  CardTitle,
  CardBody,
  CardFooter,
  Button,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { injectIntl } from "react-intl";
import { FormattedMessage } from "react-intl";

const ModifyAPLInformationPersonModal = ({
  periodId,
  students,
  supervisors,
  setInformationPersons,
  informationPersons,
  setInfoPersonUsers,
  intl,
  informationPersonIsOpen,
  toggleInformationPerson,
  saveInformationPerson,
  saveInformationPersonsAndUsersForPeriod,
  programId,
}) => {
  const [selectableInfoPersons, setSelectableInfoPersons] = useState([]);
  const [selectableUsers, setSelectableUsers] = useState([]);
  const [addNewInfoPersonOpen, setAddNewInfoPersonOpen] = useState(false);
  const [newInfoPersonsWithStudents, setNewInfoPersonsWithStudents] = useState(
    []
  );
  const [supervisorsInPeriod, setSupervisorsInPeriod] = useState([]);
  const [studentsInPeriod, setStudentsInPeriod] = useState([]);

  useEffect(() => {
    let UsersForSelect = [];
    let tempSupervisorsInPeriod = [];
    let tempStudentsInPeriod = [];
    students.forEach((stud) => {
      UsersForSelect.push({
        userType: "Student",
        value: stud.student ? stud.student : stud,
        label: stud.student ? stud.student.name : stud.name,
      });
      tempStudentsInPeriod.push(stud.student);
      stud.supervisors.forEach((sv) => {
        let supervisorForSelect = {
          userType: "AplSupervisor",
          value: sv.supervisor,
          label: sv.supervisor.name,
        };
        if (
          !tempSupervisorsInPeriod.some((supV) => supV.id === sv.supervisor.id)
        ) {
          tempSupervisorsInPeriod.push(sv.supervisor);
        }
        if (
          !UsersForSelect.some(
            (usr) => usr.value.id === supervisorForSelect.value.id
          )
        ) {
          UsersForSelect.push(supervisorForSelect);
        }
      });
      setSupervisorsInPeriod(tempSupervisorsInPeriod);
      setStudentsInPeriod(tempStudentsInPeriod);
    });
    setSelectableUsers(UsersForSelect);
    let infoPersonsToSelect = [];
    let tempInfoPersonUsers = [];
    informationPersons.forEach((tInfoPerson) => {
      if (tInfoPerson.forUsers && tInfoPerson.forUsers.length > 0) {
        tempInfoPersonUsers.push(tInfoPerson);
      } else {
        if (!infoPersonsToSelect.some((ip) => ip.value.id === tInfoPerson.id)) {
          let infoPersonForSelect = {
            value: tInfoPerson,
            label: tInfoPerson.name,
          };
          infoPersonsToSelect.push(infoPersonForSelect);
        }
      }
    });
    if (!infoPersonsToSelect.some((ip) => ip.value === "CreateNew")) {
      infoPersonsToSelect.unshift({
        label: "Skapa ny kontaktperson",
        value: "CreateNew",
      });
    }
    setNewInfoPersonsWithStudents(tempInfoPersonUsers);
    setSelectableInfoPersons(infoPersonsToSelect);
  }, [informationPersons, students, setInfoPersonUsers]);

  const handleAddInfoPerson = (infoPerson) => {
    if (infoPerson.value === "CreateNew") {
      setAddNewInfoPersonOpen(true);
    } else {
      setAddNewInfoPersonOpen(false);

      setNewInfoPersonsWithStudents((infoPersonUsers) => [
        ...infoPersonUsers,
        infoPerson.value,
      ]);
      let tempSelectableInfoPersons = [...selectableInfoPersons];
      if (!tempSelectableInfoPersons.some((ip) => ip.value === "CreateNew")) {
        tempSelectableInfoPersons.unshift({
          label: intl.formatMessage({
            id: "CreateNewInformationPerson",
          }),
          value: "CreateNew",
        });
      }
      setSelectableInfoPersons(
        selectableInfoPersons.filter((sip) => sip.value !== infoPerson.value)
      );
    }
  };

  const handleRemoveInfoPerson = (infoPerson) => {
    setNewInfoPersonsWithStudents(
      newInfoPersonsWithStudents.filter((nipws) => nipws.id !== infoPerson.id)
    );
    var tempSelectableInfoPersons = [...selectableInfoPersons];
    tempSelectableInfoPersons.push({
      label: infoPerson.name,
      value: infoPerson,
    });
    setSelectableInfoPersons(tempSelectableInfoPersons);
  };

  const handleAddAndRemoveUsersToInfoPerson = (users, infoPerson) => {
    let tempUsers = [];
    users.forEach((userArray) => tempUsers.push(userArray.value));
    let tempNewInfoPersonsWithStudents = [...newInfoPersonsWithStudents];
    tempNewInfoPersonsWithStudents.find(
      (infoperson) => infoperson.id === infoPerson.id
    ).forUsers = tempUsers;
  };

  const InfoPersonsUsers = ({ intl, person }) => {
    var selectableStudents = [];
    var selectableSupervisors = [];
    selectableUsers.forEach((user) => {
      if (
        person.forUsers?.findIndex((forUser) => {
          return forUser
            ? forUser.id === user.value.id
            : forUser.id === user.value.id;
        }) < 0
      ) {
        if (user.userType === "Student") {
          selectableStudents.push(user);
        } else if (user.userType === "AplSupervisor") {
          selectableSupervisors.push(user);
        }
      }
    });

    if (selectableStudents.length > 1) {
      let AddAllStudents = {
        value: "AllStudents",
        userType: "SelectAllStudents",
        label: intl.formatMessage({
          id: "SelectAllStudentsInPeriod",
        }),
      };
      selectableStudents.unshift(AddAllStudents);
    }

    if (selectableSupervisors.length > 1) {
      let AddAllSupervisors = {
        value: "AllSupervisors",
        userType: "SelectAllSupervisors",
        label: intl.formatMessage({
          id: "SelectAllSupervisorsInPeriod",
        }),
      };
      selectableSupervisors.unshift(AddAllSupervisors);
    }

    const groupedOptions = [
      {
        label: intl.formatMessage({
          id: "Students",
        }),
        options: selectableStudents,
      },
      {
        label: intl.formatMessage({
          id: "Supervisors",
        }),
        options: selectableSupervisors,
      },
    ];

    return (
      <Card key={person.id} className="mt-4 mb-0">
        <CardHeader>
          <FontAwesomeIcon
            icon="times-circle"
            size="1x"
            className="me-3 text-secondary"
            style={{ cursor: "pointer" }}
            onClick={() => handleRemoveInfoPerson(person)}
          />
          {person.name}
        </CardHeader>
        <Select
          menuPortalTarget={document.body}
          menuPosition={"fixed"}
          placeholder={intl.formatMessage({
            id: "ChooseWhoShouldHaveAccess",
          })}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          name="forUsers"
          defaultValue={person.forUsers?.map((person) => ({
            label: person.name,
            value: person,
          }))}
          isMulti
          options={groupedOptions}
          onChange={(event) =>
            handleAddAndRemoveUsersToInfoPerson(event, person)
          }
          noOptionsMessage={({ inputValue }) => (
            <FormattedMessage id="NoPersonsInPeriodGoBackAndAdd" />
          )}
        />
      </Card>
    );
  };

  const handleSaveInfoPersonsAndStudents = () => {
    let tempInfoPersons = [...newInfoPersonsWithStudents];
    tempInfoPersons.forEach((ip) => {
      let tempUsers = [];
      if (ip.forUsers.some((user) => user === "AllStudents")) {
        studentsInPeriod.forEach((stud) => {
          tempUsers.push(stud);
        });
        ip.forUsers = ip.forUsers.filter((user) => user !== "AllStudents");
      }
      if (ip.forUsers.some((user) => user === "AllSupervisors")) {
        supervisorsInPeriod.forEach((sv) => {
          tempUsers.push(sv);
        });
        ip.forUsers = ip.forUsers.filter((user) => user !== "AllSupervisors");
      }
      tempUsers.forEach((user) => {
        if (!ip.forUsers.some((oldlist) => oldlist.id === user.id)) {
          ip.forUsers.push(user);
        }
      });
    });

    setNewInfoPersonsWithStudents(tempInfoPersons);
    saveInformationPersonsAndUsersForPeriod(newInfoPersonsWithStudents);
  };

  return (
    <Modal isOpen={informationPersonIsOpen} toggle={toggleInformationPerson}>
      <ModalHeader>
        {" "}
        <FormattedMessage id="ContactPersons" />
      </ModalHeader>
      <Card style={{ marginBottom: "0", height: "34rem" }}>
        <CardBody style={{ overflowY: "auto" }}>
          <CardTitle>
            {" "}
            <p className="lead">
              <FormattedMessage id="ContactPersons" />
            </p>
          </CardTitle>
          <ModalBody style={{ border: "none", padding: "0" }}>
            {addNewInfoPersonOpen && (
              <CreateNewInfoPersonInModifyInfoPersons
                periodId={periodId}
                setInformationPersons={setInformationPersons}
                informationPersons={informationPersons}
                setAddNewInfoPersonOpen={setAddNewInfoPersonOpen}
                saveInformationPerson={saveInformationPerson}
              />
            )}

            <Select
              menuPortalTarget={document.body}
              menuPosition={"fixed"}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              name="infoPersons"
              placeholder={intl.formatMessage({
                id: "ChooseContactPerson",
              })}
              options={selectableInfoPersons}
              onChange={(event) => handleAddInfoPerson(event)}
              noOptionsMessage={({ inputValue }) => (
                <FormattedMessage id="NoContactPersonsAvailableCreateNew" />
              )}
            />
            {newInfoPersonsWithStudents.map((person) => (
              <InfoPersonsUsers
                key={"infopers" + person.id}
                intl={intl}
                person={person}
              />
            ))}
          </ModalBody>
        </CardBody>
        <CardFooter>
          <div className="justify-content-end d-flex">
            <Button
              color="secondary"
              outline
              className="m-2"
              onClick={() => {
                toggleInformationPerson();
              }}
            >
              <FormattedMessage id="Cancel" />
            </Button>
            <Button
              color="primary"
              outline
              className="m-2"
              onClick={() => {
                handleSaveInfoPersonsAndStudents();
              }}
            >
              <FormattedMessage id="Save" />
            </Button>
          </div>
        </CardFooter>
      </Card>
    </Modal>
  );
};

export default injectIntl(ModifyAPLInformationPersonModal);
